import { createAction, props } from '@ngrx/store';

import { IOrderFillDateRange, IOrderFillLocation, IOrderFillPattern } from '@ruby/modules/order-fill/model/order-fill.interface';
import { EOrderFillDateInterval, EOrderFillDateType } from '@ruby/shared/enums/order-fill.enums';
import { IError } from '@ruby/shared/models/request/error.interface';

export const loadLocations = createAction(
  '[Order History Filters] Load Locations',
  props<{ data: string }>()
);

export const loadLocationsSuccess = createAction(
  '[Order History Filters] Load Locations Success',
  props<{ data: Array<IOrderFillLocation> }>()
);

export const loadLocationsFailure = createAction(
  '[Order History Filters] Load Locations Failure',
  props<{ error: IError }>()
);

export const loadPatterns = createAction(
  '[Order History Filters] Load Patterns',
  props<{ data: Array<string> }>()
);

export const loadPatternsSuccess = createAction(
  '[Order History Filters] Load Patterns Success',
  props<{ data: Array<IOrderFillPattern> }>()
);

export const loadPatternsFailure = createAction(
  '[Order History Filters] Load Patterns Failure',
  props<{ error: IError }>()
);

export const updateDateInterval = createAction(
  '[Order History Filters] Update Date Interval',
  props<{ data: { previous: EOrderFillDateInterval; current: EOrderFillDateInterval } }>()
);

export const loadDateRange = createAction(
  '[Order History Filters] Load Date Range',
  props<{ data: EOrderFillDateType }>()
);

export const loadDateRangeSuccess = createAction(
  '[Order History Filters] Load Date Range Success',
  props<{ data: IOrderFillDateRange }>()
);

export const loadDateRangeFailure = createAction(
  '[Order History Filters] Load Date Range Failure',
  props<{ error: IError }>()
);

export const resetState = createAction('[Order History Filters] Reset State');
